module.exports = __webpack_public_path__ + "static/media/gestion_contratos.b21c46b6.svg";